import React from 'react';
import {useTranslation} from 'react-i18next';

import {Typography} from '@nur-portal/ui-kit';

// Components
import Loader from '../../../../website-ui/components/loader';

// Styles
import styles from './loader-card.module.css';

export const LoaderCard = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.wrapper}>
      <Typography
        variant='title-21'
      >
        {t('articleComments.loading')}
      </Typography>
      <Loader />
    </div>
  );
};
